/**
 * Move an array element in an immutable fashion.
 */
export function arrayMove(array: any[], fromIndex: number, toIndex: number) {
  const results = array.slice();
  const startIndex = fromIndex < 0 ? results.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < results.length) {
    const endIndex = toIndex < 0 ? results.length + toIndex : toIndex;
    const [item] = results.splice(fromIndex, 1);
    results.splice(endIndex, 0, item);
  }

  return results;
};
